import { render, staticRenderFns } from "./PanelDocument.vue?vue&type=template&id=9714e2c6&"
import script from "./PanelDocument.vue?vue&type=script&lang=js&"
export * from "./PanelDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports